// Compnents
import { $qs, $qsa } from '../src/utils/querySelector';
import mainMenu from './components/menu';
import accordion from './components/accordion';
import table from './components/tables';
import gallerySlider from './components/image-slider';
import admissionsWidget from './components/admissions-widget';
import map from './components/contact-map';
import instagramSlider from './components/social-media';
import 'magnific-popup';

// Templates
import Home from './templates/Home';

//Packages 
import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';

import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import SplitText from 'gsap/SplitText';
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);

function consoleMessage(){
	console.log('%cCreated by %cTWK%cwww.thewebkitchen.co.uk', 'background: #13212E; color: #FFFFFF; padding: 5px 0px 5px 10px; margin: 25px 0px;', 'background: #13212E; color: #05E5C8; padding: 5px 10px 5px 0px; font-weight: bold;', 'background: #FFFFFF; padding: 5px 10px;');
}

function usingJS(){
	document.querySelector('html').classList.remove('no-js')
	document.querySelector('html').classList.add('js')
}

/* *********************** */
/* Start all the functions */
/* *********************** */

// Init
consoleMessage()
usingJS()

// Components
mainMenu();
accordion();
table();
gallerySlider();
admissionsWidget();
map();
instagramSlider();

// Templates
Home();

const logo = $qs('.top-nav__logo');
const visitText = $qs('.js-heading-visit');
const menuHamburger = $qs('.js-hamburger-menu');
const firstTimeline = gsap.timeline();
    
firstTimeline.to(visitText, {
	autoAlpha: 1,        
	duration: 0.7
});
firstTimeline.to(logo, {
	autoAlpha: 1,        
	duration: 0.7
}, "<+=0.5");
firstTimeline.to(menuHamburger, {
	autoAlpha: 1,        
	duration: 0.7
}, "<");


if($qs('body').classList.contains('page-id-237')) {
	
	var aLevelPage = $qs('.page-item-281 a');
	var currentPageLink = aLevelPage.getAttribute('href');
	var newPageLink = currentPageLink + '#alevel';
	
	aLevelPage.setAttribute('href', newPageLink) ;
	
}

var logoSlider = document.querySelector('[data-element="logo-slider"]')
if(window.matchMedia('(min-width:828px').matches) {
	var swiper = new Swiper(logoSlider, {       
		modules: [ Autoplay ],  
		slidesPerView: 2,
		spaceBetween: 80,
		loop: true,              
		allowTouchMove: false,
	
	    autoplay: {
	        delay: 2000,
		
	      },
		breakpoints: {
			700: {
				spaceBetween: 180,
				slidesPerView: 3,
			},
			828: {			
				slidesPerView: 3,
				spaceBetween: 90,
			},
			1124: {
				slidesPerView: 4,
				spaceBetween: 90,
			},
			1200: {
				slidesPerView: 4,
				spaceBetween: 140,
			}
		}
	});
}
    
var intros = $qsa('[data-name=content-editor] .intro');
var heading2  = $qsa('[data-name=content-editor] h2');
var regularText = $qsa('[data-name=content-editor] p:not(.intro), [data-name=content-editor] h3, [data-name=content-editor] ul');

// [...intros].forEach(intro => {
// 	intro.classList.add('js-line-by-line');	
// 	intro.classList.add('opacity-0');	
// });
[...heading2].forEach(h2 => {
	h2.classList.add('js-title-animation');
});
// [...regularText].forEach(text => {
// 	text.classList.add('js-fade-up-text');
// 	text.classList.add('opacity-0');	

// });

// history line animations

var lineDown = $qsa('.js-line-down');	
var lineAcross = $qsa('.js-line-across');
[...lineDown].forEach(down => {
	if(down.classList.contains('js-banner-down')) {
		var duration = 1.7;
		var startPoint = "top bottom"
	} else {
		if(down.classList.contains('js-little-down')) {
			var duration = 0.7;
			var startPoint = "top center+=250";
		} else {
			var duration = 2.5;
			var startPoint = "top center+=250";
		}
	}
	if(lineDown.length) {
		gsap.from(down, {
			height: 0,
			duration: duration,	
			scrollTrigger: {
				trigger: down,
				start: startPoint,
				ease: "power4.out",												
			}
		})
	}
});
[...lineAcross].forEach(across => {
	if(lineAcross.length) {
		gsap.from(across, {
			width: 0,
			duration: 2.5,		
			scrollTrigger: {
				trigger: across,
				start: "top bottom-=150px",
				ease: "power4.out",
				// markers: true
			}
		})
	}
});	


//loading animations
setTimeout(function() {
	var animateBlock = $qsa('.animate-block');	
	[...animateBlock].forEach(block => {				
		var loadingTimeline = gsap.timeline({
			scrollTrigger: {
				trigger: block,
				start: "top bottom-=50px",
				ease: "power4.out",
			}
		});
		const titleAnim = $qsa('.js-title-animation', block);		
		[...titleAnim].forEach(title => {  		
			gsap.to(title, {opacity: 1});
			var split = new SplitText(title, { type: "chars,lines" });
			var titleLines = $qsa(".js-title-animation > div", title);

			[...titleLines].forEach(line => {
				line.style.overflow = "hidden";
			});	
			[...titleLines].forEach(titleLine => {
				
				var titleLetters = $qsa("div", titleLine);                   
				
				// console.log(bannerSplitLetters) 
				loadingTimeline.fromTo(titleLetters, { 
					opacity: 0, 
					y: '155px' 
				}, { 					
					opacity: 1, 
					y: 0, 
					duration: 1, 	
					stagger: 0.045,				
					ease: "power4.out",         
				}, "<");		
			});
		});

		var lineByLine = $qsa('.js-line-by-line', block);
		[...lineByLine].forEach(intro => {  		
			gsap.to(intro, {opacity: 1});
			var splitIntro = new SplitText(intro, { type: "lines" });
			var introLines = $qsa(".js-line-by-line > div", intro);

			[...introLines].forEach(line => {
				var wrapper = document.createElement('div');        
        		wrapper.classList.add('overflow-hidden');
        		line.parentNode.insertBefore(wrapper, line);
        		wrapper.appendChild(line);
				line.style.overflow = "hidden";
			});				
			loadingTimeline.fromTo(introLines, { 
				opacity: 0, 
				y: '155px' 
			}, { 					
				opacity: 1, 
				y: 0, 
				duration: 0.7, 	
				stagger: 0.045,				
				ease: "power4.out",         
			});					
		});
		var fadeUp = $qsa('.js-fade-up', block);
		var fadeUpText = $qsa('.js-fade-up-text', block);
		var fadeIn = $qsa('.js-fade-in', block);
		var revealLeft = $qsa('.js-reveal-left', block);
		var revealRight = $qsa('.js-reveal-right', block);
		var revealUp = $qsa('.js-reveal-up', block);
		var quoteSequence = $qsa('.js-quote-sequence', block);
		var quoteImage = $qs('.js-quote-sequence img', block);
		var quoteBefore = $qs('.js-quote-sequence .quote-before', block);
		var quoteAfter = $qs('.js-quote-sequence .quote-after', block);

		if(fadeUp.length) {
			loadingTimeline.fromTo(fadeUp, {
				opacity: 0,
				y: "190px",
			}, {
				ease: 'linear',
				opacity: 1,
				y: 0,
				duration: 0.6,
				stagger: 0.1,
			}, "<");
		}
		if(fadeUpText.length) {
			loadingTimeline.fromTo(fadeUpText, {
				opacity: 0,
				y: "190px",
			}, {
				ease: 'linear',
				opacity: 1,
				y: 0,
				duration: 0.6,
				// stagger: 0.1,
			}, "<+=0.5");
		}
		if(revealLeft.length) {
			loadingTimeline.from(revealLeft, {
				xPercent: -100,
				ease: "power4.out",
				duration: 1.2
			}, "<")
		}
		if(revealRight.length) {
			loadingTimeline.from(revealRight, {
				xPercent: 100,
				ease: "power4.out",
				duration: 1.2
			}, "<")
		}
		if(revealUp.length) {
			loadingTimeline.from(revealUp, {
				yPercent: 100,
				ease: "power4.out",
				duration: 1.2
			}, "<")
		}
		if(fadeIn.length) {
			loadingTimeline.to(fadeIn, {
				opacity: 1,
				duration: 0.6,
				stagger: 0.35,
			}, "<")
		}
		if(quoteSequence.length) {
			loadingTimeline.to(quoteImage , {
				opacity: 1,
				duration: 0.7
			})
			loadingTimeline.from(quoteBefore , {
				width: "0%",
				duration: 0.7,
				transformOrigin: '100% 50%',
			},">-=0.5")
			loadingTimeline.from(quoteAfter , {
				width: "0%",
				duration: 0.7,
				transformOrigin: '0 50%',
			
			}, "<")
		}
	});
	
}, 1000)

jQuery(document).ready(function ($) {
	anchorlinks: {	
		$(document).on('click', 'a#btn-search', function (event) {
			event.preventDefault();
		});		
		$(document).on('click', '[data-scroll-to]', function (event) {
			event.preventDefault();

			$('html, body').animate({
				scrollTop: $($.attr(this, 'href')).offset().top - 50
			}, 500);
		});
		$(document).on('click', '.scroll-to', function (event) {
			event.preventDefault();

			$('html, body').animate({
				scrollTop: $($.attr(this, 'href')).offset().top - 50
			}, 500);
		});
	}
	magnificPopup: {
	$(document).on("sf:ajaxfinish", ".searchandfilter", function(){
		console.log("ajax complete");
		//so load your lightbox or JS scripts here again
		$('.magnific-inline-popup').magnificPopup({
            type: 'inline',

			fixedContentPos: true,
			overflowY: 'hidden',			
			fixedBgPos: true,

			overflowY: 'auto',

			closeBtnInside: true,
			preloader: false,
			
			midClick: true,
			removalDelay: 300,
			mainClass: 'my-mfp-zoom-in'
        });
	});
	$('[data-target="magnific-video"], .magnific-video').magnificPopup({
		type: 'iframe',
		mainClass: 'mfp-video-wrapper',
		removalDelay: 160,
		preloader: false,
		fixedContentPos: false,

		iframe: {
			markup: '<div class="mfp-iframe-scaler">' +
				'<div class="mfp-close"></div>' +
				'<iframe class="mfp-iframe" frameborder="0" allow="autoplay"></iframe>' +
				'</div>',
			patterns: {
				youtu: {
					index: 'youtu.be',
					id: function( url ) {
					
						// Capture everything after the hostname, excluding possible querystrings.
						var m = url.match( /^.+youtu.be\/([^?]+)/ );
				
						if ( null !== m ) {
							return m[1];
						}
				
						return null;
			
					},
					// Use the captured video ID in an embed URL. 
					// Add/remove querystrings as desired.
					src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0'
				},
				youtube: {
					index: 'youtube.com/',
					id: 'v=',
					src: 'https://www.youtube.com/embed/%id%?autoplay=1'
				}
			}
		}
	});
	$('.magnific-inline-popup').magnificPopup({
		type: 'inline',

					
			fixedContentPos: true,
			overflowY: 'hidden',	
		fixedBgPos: true,

		overflowY: 'auto',

		closeBtnInside: true,
		preloader: false,
		
		midClick: true,
		removalDelay: 300,
		mainClass: 'my-mfp-zoom-in'
	});
	}
	externallinks: {
		$('a[href^="mailto:"]').each(function () {
			$(this).addClass('email-link');
		});	 
		
		$('a:not(.email-link):not([class^="magnific-"])').each(function () {
			var a = new RegExp('/' + window.location.host + '/');
			
			if (!a.test(this.href)) {
				$(this).click(function (event) {
				event.preventDefault();
				window.open(this.href, '_blank');
				});
			}
		});
		pdfs: {
			// Open PDFs in new window
			$(function () {
				$('a[href$=".pdf"]').prop('target', '_blank');
			});
		}
	}
});


;(function(window) {

	'use strict';

	var openCtrl = document.getElementById('btn-search'),
		closeCtrl = document.getElementById('btn-search-close'),
		searchContainer = document.querySelector('.search-lightbox'),
		inputSearch = searchContainer.querySelector('.search__input');

	function init() {
		initEvents();	
	}

	function initEvents() {
		openCtrl.addEventListener('click', openSearch);
		closeCtrl.addEventListener('click', closeSearch);
		document.addEventListener('keyup', function(ev) {
			
			$('.fake-placeholder').hide();
			
			// escape key.
			if( ev.keyCode == 27 ) {
				closeSearch();
			}
		});

		$('.search__form').on("blur","input",function(){
			
		    if( !$(this).val() ) {
			    
		        $('.fake-placeholder').show();
		          
		    } else {
			    
		    }			
		});		
	}

	function openSearch() {
		searchContainer.classList.add('search--open');
		inputSearch.focus();
	}

	function closeSearch() {
		searchContainer.classList.remove('search--open');
		inputSearch.blur();
		inputSearch.value = '';
	}
	
	init();

})(window);
